import type { StateMachine } from './machine';
import { TICKET_STATES, type TicketState } from '../constants/tickets';

/**
 * A ticket's status (ops insights Phase 5a, spec §2). The office works it from `new` to
 * `resolved`, waiting on the customer or on parts along the way.
 *
 * Each `via` is the write that makes the move, so a write can only make its own moves:
 *
 *  - `ticket.assign` opens a `new` ticket. Claiming one is assigning it to yourself, so there
 *    is no other way out of `new` except resolving it.
 *  - `ticket.transition` moves between `open` and the two waits, and reopens a resolved one.
 *  - `ticket.resolve` resolves from anywhere unresolved. It needs what fixed it and a root
 *    cause, which a CHECK on `tickets` also demands.
 *
 * `resolved` is deliberately NOT terminal: the leak that comes back next week is the same
 * ticket, and reopening it clears the resolution (the same CHECK).
 */
const WAITS = ['waiting_customer', 'waiting_parts'] as const;

export const ticketMachine: StateMachine<TicketState> = {
  states: TICKET_STATES,
  initial: 'new',
  terminal: [],
  transitions: [
    { from: 'new', to: 'open', via: 'ticket.assign' },
    ...WAITS.flatMap((wait) => [
      { from: 'open' as const, to: wait, via: 'ticket.transition' },
      { from: wait, to: 'open' as const, via: 'ticket.transition' },
    ]),
    ...(['new', 'open', ...WAITS] as const).map((from) => ({
      from,
      to: 'resolved' as const,
      via: 'ticket.resolve',
    })),
    { from: 'resolved', to: 'open', via: 'ticket.transition' },
  ],
};
